import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPuzzle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="puzzle, plugin"><path d="M9.5 4V3.5C9.5 2.11929 10.6193 1 12 1C13.3807 1 14.5 2.11929 14.5 3.5V4H19.25C20.2165 4 21 4.7835 21 5.75V9C21 9.27614 20.7761 9.5 20.5 9.5C19.1193 9.5 18 10.6193 18 12C18 13.3807 19.1193 14.5 20.5 14.5C20.7761 14.5 21 14.7239 21 15V18.25C21 19.2165 20.2165 20 19.25 20H4.75C3.7835 20 3 19.2165 3 18.25V5.75C3 4.7835 3.7835 4 4.75 4H9.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPuzzle;
